import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminPartnerEdit_template } from '../../components/templates/recruiting/adminPartnerEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_partner_edit extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_partner_edit';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Partner');
        this.tpl = new adminPartnerEdit_template('adminPartnerEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading partner...');
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/offer/references', [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for references.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setReferences(responseParsed);
                obj.loadPartner();
            });
            if (req.request.readyState === 4 && req.request.status !== 0 && !obj.getPartnerId()) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Load partner data from the API.
     *
     * @return void
     */
    loadPartner() {
        const partnerId = this.getPartnerId();
        if (!partnerId) {
            this.tpl.setPartner({ partnerStatus: 1 });
            hideLoadingOverlay(this.tpl.builtTemplate);
            return;
        }
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/offer/' + partnerId, [], this);
        this.XHRHdl.onReadyStateFunction = this.onPartnerReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for partner.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onPartnerReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setPartner(responseParsed);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Save partner through the API.
     *
     * @return Promise<void>
     */
    async savePartner() {
        const payload = this.tpl.getPayload();
        if (!payload.name) {
            alert('Display name is required.');
            return;
        }
        if (!payload.internalName) {
            alert('Internal name is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving partner...');
        const response = await fetch('/api/admin/rest/api/lead/offer', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ partner: payload }),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save partner.');
            return;
        }
        page('/admin/offerManagement/' + result.objectId);
    }
    /**
     * Delete partner through the API.
     *
     * @return Promise<void>
     */
    async deletePartner() {
        const partnerId = this.getPartnerId();
        if (!partnerId || !confirm('Delete this partner?')) {
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Deleting partner...');
        const response = await fetch('/api/admin/rest/api/lead/offer/' + partnerId, {
            method: 'DELETE',
            credentials: 'same-origin',
        });
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok) {
            alert('Unable to delete partner.');
            return;
        }
        page('/admin/offerManagement');
    }
    /**
     * Navigate back to partners.
     *
     * @return void
     */
    backToPartners() {
        page('/admin/offerManagement');
    }
    /**
     * Handle add partner question.
     *
     * @return void
     */
    addPartnerQuestion() {
        const partnerId = this.getPartnerId();
        const suffix = partnerId > 0 ? '?partnerId=' + partnerId : '';
        page('/admin/leadQuestion/new' + suffix);
    }
    /**
     * Navigate to edit partner question.
     *
     * @param row any
     * @return void
     */
    editPartnerQuestion(row) {
        if (!row || !row.id) {
            alert('Unable to open this question.');
            return;
        }
        const partnerId = this.getPartnerId();
        const suffix = partnerId > 0 ? '?partnerId=' + partnerId : '';
        page('/admin/leadQuestion/' + row.id + suffix);
    }
    /**
     * Navigate to edit partner contract.
     *
     * @param row any
     * @return void
     */
    editPartnerContract(row) {
        if (!row || !row.id) {
            alert('Unable to open this contract.');
            return;
        }
        page('/admin/contract/' + row.id);
    }
    /**
     * Navigate to create partner contract.
     *
     * @return void
     */
    createPartnerContract() {
        page('/admin/contract/new');
    }
    /**
     * Navigate to edit partner transmission.
     *
     * @param row any
     * @return void
     */
    editPartnerTransmission(row) {
        if (!row || !row.id) {
            alert('Unable to open this transmission.');
            return;
        }
        page('/admin/transmission/' + row.id);
    }
    /**
     * Handle add partner creative.
     *
     * @return void
     */
    addPartnerCreative() {
        const partnerId = this.getPartnerId();
        page(partnerId ? '/admin/creative/new?partnerId=' + partnerId : '/admin/creative/new');
    }
    /**
     * Navigate to edit partner creative.
     *
     * @param row any
     * @return void
     */
    editPartnerCreative(row) {
        if (!row || !row.id) {
            alert('Unable to open this creative.');
            return;
        }
        page('/admin/creative/' + row.id);
    }
    /**
     * Return partner id.
     *
     * @return number
     */
    getPartnerId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
}
